import React, { useState } from 'react';
import { Card, Button, Tag, Modal } from 'antd';
import { CheckCircleOutlined, FileTextOutlined } from '@ant-design/icons';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import PdfViewer from '../pageComponents/PdfViewer';
const { Meta } = Card;

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const AssignmentCard = ({ title, description, dueDate, status, avatarSrc, pdfUrl }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Card className="relative">
            <Meta title={title} description={description} />
            <div className="my-2">
                <p>Due Date: {dueDate}</p>
            </div>
            <div className="absolute top-0 right-[-0.5rem] mb-3">
                <Tag color={status === 'Completed' ? 'green' : 'volcano'}>
                    {status === 'Completed' ? <CheckCircleOutlined /> : 'Pending'}
                </Tag>
            </div>
            <Button
                className="ml-auto block"
                type="primary"
                icon={<FileTextOutlined />}
                onClick={showModal}
            >
                View
            </Button>
            <Modal
                title="Assignment PDF"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width="80%"
            >
                <PdfViewer url={pdfUrl} />
            </Modal>
        </Card >
    );
};

export default AssignmentCard;
